export const setItemRequest_v1_schema = {
  type: 'object',
  properties: {
    key: {
      type: 'string',
    },
    value: {},
  },
  required: ['key', 'value'],
};
